export function stringToReferenceCodeFormat(
  string_: string | number = ''
): string {
  const chunkedString = String(string_).match(/.{1,4}/g);

  return chunkedString ? chunkedString.join(' ').trim() : '';
}
